export default {
  // TODO Verify which colors that are used and what components/ui files that are used
  color: {
    white: '#fff',
    offWhite: '#f7f7f7',
    offWhiteDarker: '#f2f2f2',
    black: '#333',
    lightGray: '#eee',
    gray: '#ccc',
    midGray: '#999',
    midDarkGray: '#666',
    blue: '#0058a3',
    blueActive: '#2d6596',
    blueDisabled: '#6695c1',
    blueHeader: '#0051ba',
    blueHeaderSwe: '#025ca9',
    orange: '#ca5007',
    familyOrange: '#cf4319',
    familyOrangeActive: '#d75027',
    yellow: '#ffce00',
    red: '#f00'
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  zIndex: {
    dropdown: 2000
  },
  section: {
    padding: '32px'
  },
  card: {
    width: '220px'
  }
};
